import FSMState from '@src/slide/infrastructure/module/independent/state-machine/fsm-state';
import { BOOT_STATE_TYPE } from '@src/js/service/boot-service/boot-manager.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorViewableServiceLayer } from '@src/slide/application/entry/toc/editor/pc/service-layer/viewable-service-layer.interface';
import { IPcEditorEditableServiceLayer } from '@src/slide/application/entry/toc/editor/pc/service-layer/editable-service-layer.interface';
import pureTaskQueue, { LongTaskModel } from '@src/slide/infrastructure/module/dependent/taskManager/pure-task-queue';
import { commonRequestIdleCallback } from '@src/slide/infrastructure/module/dependent/idle-loader';

export default class PcFirstScreenLoadedState extends FSMState {
    public constructor() {
        super(BOOT_STATE_TYPE.firstScreenDidLoad);
    }

    public enterCallback() {
        // 重置计时器
        this.duration = 0;

        // 任务队列切换成高fps模式
        pureTaskQueue.switchLongTaskLimit(LongTaskModel.SMOOTH);

        this.getAppService().viewableServiceLayer.notifyManager.promise();

        import(
            /* webpackChunkName: "service" */ '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager')
            .then((module) => {
                const EditorAnimPreviewManager = module.default;
                EditorAnimPreviewManager.getInstance().initWithStore({
                    selectionService: this.getAppService().viewableServiceLayer.selectionService,
                    mediaManager: this.getAppService().viewableServiceLayer.mediaManager,
                    playManager: this.getAppService().viewableServiceLayer.playManager,
                    animManager: this.getAppService().viewableServiceLayer.animManager,
                    rightSideBarManager: this.getAppService().editableServiceLayer?.rightSideBarManager,
                });
                this.getAppService().viewableServiceLayer
                    .setEditorAnimPreviewManager(EditorAnimPreviewManager.getInstance());
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
        import(/* webpackChunkName: "service" */ '@src/slide/application/service/number-test-manager/number-test-manager')
            .then((module) => {
                const NumberTestManager = module.default;
                this.getEditableServiceLayer().numberTestManager = new NumberTestManager();
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });

        this.getAppService().editableServiceLayer?.copyPasteManager.promise();
        commonRequestIdleCallback?.(() => {
            this.getAppService()?.editableServiceLayer?.ratingService?.promise().then((ratingService) => {
                ratingService.autoShow();
            });
        });
    }

    private getEditableServiceLayer(): IPcEditorEditableServiceLayer {
        return this.getAppService().editableServiceLayer!;
    }

    private getViewableServices(): IPcEditorViewableServiceLayer {
        return this.getAppService().viewableServiceLayer;
    }

    private getAppService(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
